<template>
    <div :class="{v2ContainerCls:v2ContainerCls,v3Cls:v3Cls}">
        <head-page></head-page>
        <div class="home_content container-fluid row pl-0 pr-0 m-0" id="myapp">
            <div class="col-md-1 col-sm-1 left_content pl-0 pr-0 nav-show-sty">
                <nav class="bd-links navsticky collapse" id="bd-docs-nav">
                    <home-list></home-list>
                </nav>
            </div>
            <keep-alive>
                <router-view class="row col-md-11 col-sm-11 m-0 p-0" v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view class="row col-md-11 col-sm-11 m-0 p-0" v-if="!$route.meta.keepAlive"></router-view>
        </div>
        <footer
                class="fixed-bottom"
                v-show="$store.state.footerShow"
                v-if="$store.state.hasFooter"
                :class="{'cur':!$store.state.footerShow}"
        >
            <footerpage></footerpage>
        </footer>
    </div>
</template>

<script>
import homeList from '@/views/silkRoadBase/components/homeList.vue' //左侧列表
import headPage from '@/views/silkRoadBase/components/headPage.vue' //头部列表
import footerpage from '@/views/silkRoadBase/components/footerpage.vue' //底部列表
import {getToken} from '@/common/js/http/pdAxios'

export default {
  components: {
    homeList,
    headPage,
    footerpage
  },

  data () {
    return {
      v2ContainerCls: false,
      v3Cls: false
    }
  },

  created () {
    // brpa 设置主题
    let theme = sessionStorage.getItem('theme') ? sessionStorage.getItem('theme') : 'white';
    let link = document.createElement('link');
    link.rel  = "stylesheet"
    link.type = "text/css"
    link.id = 'theme'
    link.href = './static/css/theme/' + theme + '.css';
    document.getElementsByTagName('head')[0].appendChild(link)

    // this.Cookies.set('imsilkroad_username','imtest');
    // this.Cookies.set('imsilkroad_userid',3091);
    getToken()
  },

  watch: {
    $route (newValue) {
      // console.log("TCL: $route -> newValue", newValue);
      // 二期
      if (newValue.meta.tagV && newValue.meta.tagV == 'v2') {
        this.v2ContainerCls = true
      } else this.v2ContainerCls = false

      // 三期
      if (newValue.path.includes('brand')) {
        this.v3Cls = true
      } else this.v3Cls = false
    }
  }
}
</script>

<style>
    @media only screen and (max-width: 766px) {
        .nav-show-sty {
            width: 100% !important;
            max-width: 100% !important;
        }
    }
</style>
<style lang="less">
    .el-scrollbar {
        > .el-scrollbar__bar {
            opacity: 1 !important;
        }
    }
</style>

